import { CloseOutlined } from '@ant-design/icons';
import { Modal as Modalantd } from 'antd';
import React, { CSSProperties, ReactNode, useEffect } from 'react';
import styles from './modal.module.scss';

type Props = {
	visible: boolean;
	onClickOk?: () => void;
	onCancel?: () => void;
	title?: string | ReactNode;
	className?: string;
	footer?: React.ReactNode[];
	width?: string | number;
	style?: CSSProperties;
	customZoomClass?: string;
	keyboard?: boolean;
	maskClosable?: boolean;
	destroyOnClose?: boolean;
	bodyStyle?: React.CSSProperties;
	closable?: boolean;
	maskStyle?: React.CSSProperties;
	closeIconId?: string;
	nestedModal?: boolean;
};

const Modal: React.FC<Props> = ({
	visible,
	onClickOk,
	children,
	title,
	className,
	onCancel,
	footer,
	width,
	style,
	customZoomClass,
	keyboard = false,
	maskClosable = false,
	destroyOnClose,
	bodyStyle,
	closable,
	maskStyle,
	closeIconId = 'closeModalIcon',
	nestedModal,
}) => {
	///remove scroll when modal is opened
	useEffect(() => {
		document.body.style.overflow = 'hidden';
		return () => {
			if (!nestedModal) {
				document.body.style.overflow = 'auto';
			}
		};
	}, []);

	const closeIconElement = <CloseOutlined id={closeIconId} />;

	return (
		<Modalantd
			keyboard={keyboard}
			closable={closable}
			destroyOnClose={destroyOnClose}
			maskClosable={maskClosable}
			visible={visible}
			className={className}
			title={title}
			wrapClassName={customZoomClass || styles.WithModalZoom}
			onOk={onClickOk}
			onCancel={onCancel}
			centered
			width={width}
			bodyStyle={bodyStyle}
			style={style}
			maskStyle={maskStyle}
			footer={footer ? [...footer] : null}
			closeIcon={closeIconElement}>
			{children}
		</Modalantd>
	);
};

export { Modal };
